import useShouldShowPrompt from './useShouldShowPrompt';

const iOSInstallPromptedAt = 'iOSInstallPromptedAt';

const isIOS = () => {

    if ( navigator.standalone ) {

        return false;

    }

    const isIPad   = !! navigator.userAgent.match( /iPad/i );
    const isIPhone = !! navigator.userAgent.match( /iPhone/i );

    return isIPad || isIPhone;

};

const useIOSInstallPrompt = () => {

    const [ userShouldBePromptedToInstall, handleUserSeeingInstallPrompt ] = useShouldShowPrompt( iOSInstallPromptedAt );

    return [ isIOS() && userShouldBePromptedToInstall, handleUserSeeingInstallPrompt ];

};

export default useIOSInstallPrompt;